export default "__VITE_ASSET__BpHLpr8h__"